import React, { useState, useMemo, useEffect } from 'react';
import { Box, Typography, MenuItem, useMediaQuery } from '@mui/material';
import { CustomButton, StandardChip, CustomSelect } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
// import { getLanguagesAction } from '../../API/Action';
import CustomChip from '../../../Components/CustomChip';

const questionConfig = getQuestionConfig(ProfilerQuestionID.PREFERRED_LANGUAGE);

const PrefferedLanguage = ({
  questionId = ProfilerQuestionID.PREFERRED_LANGUAGE,
  title = questionConfig?.question,
  subtitle = '',
  value,
  defaultValue = null,
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = { preferred: [], others: [] },
}) => {
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selected = isControlled ? value : internalValue;
  function normalizeOptions(opts) {
    if (!Array.isArray(opts)) return [];
    if (opts.length === 0) return [];
    if (typeof opts[0] === 'string') {
      return opts.map(l => ({ value: l, label: l }));
    }
    return opts;
  }
  // Use only options prop for languageOptions
  const preferred = normalizeOptions(options.preferred);
  const others = normalizeOptions(options.others);

  const handleSelect = (lang) => {
    if (!isControlled) setInternalValue(lang);
    onChange?.(lang);
  };
  const handleRemove = () => {
    if (!isControlled) setInternalValue(null);
    onChange?.(null);
  };
  const unselectedPreferred = preferred.filter(opt => opt.value !== selected);
  const availableOthers = others.filter(opt => opt.value !== selected);

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selected ?? null }
      ]
    });
  };

  return (
    <Box sx={cardStyles({ width: '100%', maxWidth: { xs: 250, md: 300 } })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between', gap: 1 }}>
        <Box component='img' alt='Preffered language' width={128} src={PROFILER_IMAGES.preffered_language}  />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
          <CardHeader title={title} subtitle={subtitle} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {selected && (
                <CustomChip
                  key={selected}
                  label={selected}
                  selected={true}
                  onDelete={handleRemove}
                  size={isMobile ? 'small' : 'default'}
                />
              )}
              {unselectedPreferred.map(opt => (
                <CustomChip
                  key={opt.value}
                  label={opt.label}
                  onClick={() => handleSelect(opt.value)}
                  size={isMobile? 'small' : 'default' }
                />
              ))}
            </Box>
            {availableOthers.length > 0 && (
              <CustomSelect
                size="small"
                value={''}
                displayEmpty
                onChange={e => handleSelect(e.target.value)}
                placeholder={'Choose additional languages'}
                
              >
                {availableOthers.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </CustomSelect>
            )}
          </Box>
        </Box>
        <CustomButton
          size='small'
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selected}
          sx={{ width: '100%' }}
        />
      </Box>
    </Box>
  );
};

export default PrefferedLanguage;
